import { useEffect, useState } from 'react';

import AdminLayout from '../../Layouts/AdminLayout';

import BlockContent from '../../Components/Manager/BlockContent';
import { useNotification } from '../../Contexts/NotificationContext';

function App() {
    const { setNotification } = useNotification();
    const [slides, setSlides] = useState([]);
    const [releases, setReleases] = useState([]);
    const [socialLinks, setSocialLinks] = useState([]);
    const [loading, setLoading] = useState(true);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const fetchRealeases = async () => {
        try {
            const response = await fetch(`${baseUrl}/manager/produtos/lancamentos/`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                const releasesData = await response.json();
                setReleases(releasesData.lancamentos || []);
            } else {
                throw new Error('Erro ao buscar os lançamentos.');
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const fetchSlides = async () => {
        try {
            const response = await fetch(`${baseUrl}/manager/slides/`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const slidesData = await response.json();
                setSlides(slidesData.slides || []);
            } else {
                throw new Error('Erro ao buscar os slides.');
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const fetchSocialLinks = async () => {
        try {
            const response = await fetch(`${baseUrl}/manager/redes-sociais/`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const socialLinksData = await response.json();
                setSocialLinks(socialLinksData.redes_sociais || []);
            } else {
                throw new Error('Erro ao buscar as redes sociais.');
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSlides();
        fetchRealeases();
        fetchSocialLinks();
    }, []);

    const contentSlides = {
        nome: ['Slides', 'slide'],
        route: 'slides',
        imagens: true,
        imgClass: '!max-w-full',
        editavel: true,
        conteudo: slides,
        onUpdate: fetchSlides,
    };

    const contentReleases = {
        nome: ['Lançamentos', 'lançamento'],
        route: 'produtos',
        imagens: true,
        editavel: true,
        conteudo: releases,
        onUpdate: fetchRealeases,
    };

    const contentSocialLinks = {
        nome: ['Redes Sociais', 'rede social'],
        route: 'redes-sociais',
        imagens: false,
        editavel: true,
        conteudo: socialLinks,
        onUpdate: fetchSocialLinks,
    };

    return (
        <AdminLayout>
            <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
                <div className="mt-4 grid grid-cols-12 gap-4 md:mt-4 md:gap-6 2xl:mt-7.5 2xl:gap-7.5">
                    <div className="col-span-12">
                        <BlockContent content={contentSlides} loading={loading} />

                        <BlockContent content={contentReleases} loading={loading} />

                        <BlockContent content={contentSocialLinks} loading={loading} />
                    </div>
                </div>
            </div>
        </AdminLayout>
    );
}

export default App;
